import React, { useMemo } from 'react';
import _keyBy from 'lodash/keyBy';

import LayoutSettingCard from 'molecules/LayoutSettingCard';

import { Field } from '@sift/types';
import * as Types from 'pages/Features/typings';
import * as FormValues from 'types/FormValue';
import parentFieldIsObjectArray from 'helpers/parentFieldIsObjectArray';
import isFieldValidConfigOption from 'helpers/isFieldValidConfigOption';

export const CARD_CONTENT_SUBTITLE_COPY =
  'Select the attributes that are available to be displayed on your Extended org chart cards as additional attributes.';

interface Props {
  fields: Field[];
  values: Types.FeatureValues;
  userStatus: number;
  onChange: (field: string, value: FormValues.FormValue) => void;
}

function customAttributesFilter(field: Field, fields: Field[]) {
  const VALID_FIELD_TYPES = ['text', 'textSelect', 'boolean', 'number', 'date'];

  return (
    VALID_FIELD_TYPES.includes(field.type) &&
    isFieldValidConfigOption(field, { whitelistObjectKeys: ['timezoneAndWorkHours.timezone'] }) &&
    !parentFieldIsObjectArray(field, fields)
  );
}

function ModernViewCustomContent({ fields, values, userStatus, onChange }: Props) {
  const keyedFields = useMemo(() => _keyBy(fields, 'objectKey'), [fields]);

  return (
    <LayoutSettingCard
      cardTitle="Card Content Attributes"
      dialogTitle="Card Content Attributes"
      filter={field => customAttributesFilter(field, fields)}
      layoutKey="org-chart-custom-attributes"
      subtitle={CARD_CONTENT_SUBTITLE_COPY}
      userStatus={userStatus}
      fields={keyedFields}
      onChange={onChange}
      values={values}
      typeKey="user"
    />
  );
}

export default ModernViewCustomContent;
